/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Column1,
  Column2,
  GalleryContainer,
  GalleryWrapper,
  InfoRow,
  GalleryNftImage,
  GalleryDetailsTop,
  GalleryTopHeader,
  DetailsWrapper,
  DetailsSmallHeader,
  DetailsText,
  Divider,
  GalleryWhiteWrapper,
  ErrorWrapper,
  ErrorHeader,
  ErrorText,
  Divider2,
  Timetext,
} from './galleryDetailsElements';
import { axiosSatnav } from '../../Api/axios';
import LoadingSection from '../Loading';
import Map from '../Map';

// Temp
import imgDay from '../../Images/exampleNFT.png';
import imgNight from '../../Images/exampleNFT2.png';

const index = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [nftData, setNftData] = useState({});
  const [carbonSeq, setCarbonSeq] = useState(0);

  const currentTimeHour = new Date().getUTCHours();
  const currentTimeMinutes = new Date().getUTCMinutes();

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const GetNftData = async () => {
    await axiosSatnav.get(`${state.Hectare}/${state.NFT_ID}`).then((res) => {
      if (res.data.status === 200) {
        setNftData(res.data.data);
      } else {
        setError(true);
        setTimeout(() => {
          navigate('/gallery');
        }, 3000);
      }
      setLoading(false);
    }).catch((err) => {
      setError(true);
      console.error(err);
      setTimeout(() => {
        navigate('/gallery');
      }, 3000);
    });
  };

  useEffect(() => {
    if (!state) navigate('/gallery');
    else GetNftData();
  }, []);

  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <GalleryContainer>
      <GalleryDetailsTop>
        <GalleryTopHeader>
          {`Carbon Collectible NFT #${state?.NFT_ID}`}
        </GalleryTopHeader>
      </GalleryDetailsTop>
      <GalleryWrapper>
        <GalleryWhiteWrapper>
          {error ? (
            <ErrorWrapper>
              <ErrorHeader>Error when loading</ErrorHeader>
              <ErrorText>
                There was a problem when loading NFT details.
                Please try again later.
              </ErrorText>
              <ErrorText>
                Navigating back to gallery...
              </ErrorText>
            </ErrorWrapper>
          ) : (
            <InfoRow>
              <Column1>
                <GalleryNftImage alt="nft image" src={currentTimeHour > 19 || currentTimeHour < 7 ? imgNight : imgDay} />
                <Timetext>{`Current time in forest: ${currentTimeHour}:${currentTimeMinutes < 10 ? `0${currentTimeMinutes}` : currentTimeMinutes}${currentTimeHour > 19 || currentTimeHour < 7 ? ' (Night)' : ' (Day)'}`}</Timetext>
              </Column1>
              <Column2>
                {loading ? <LoadingSection isSmall /> : (
                  <DetailsWrapper>
                    <DetailsSmallHeader>Details:</DetailsSmallHeader>
                    <DetailsText>
                      <span>ID:</span>
                      {` ${state.NFT_ID}`}
                    </DetailsText>
                    <Divider />
                    <DetailsText>
                      <span>Hectare:</span>
                      {` ${Capitalize(state.Hectare)}`}
                    </DetailsText>
                    <Divider />
                    <DetailsText>
                      <span>Latitude:</span>
                      {` ${nftData.hLatLng[0]}`}
                    </DetailsText>
                    <Divider />
                    <DetailsText>
                      <span>Longitude:</span>
                      {` ${nftData.hLatLng[1]}`}
                    </DetailsText>
                    <Divider />
                    <DetailsText>
                      <span>Mint date:</span>
                      {` ${state.Mint_Date}`}
                    </DetailsText>
                    <Divider />
                    <DetailsText>
                      <span>Expiration date:</span>
                      {` ${state.Exp_Date}`}
                    </DetailsText>
                    <Divider />
                    <DetailsText>
                      <span>Owned by:</span>
                      {` ${state.Wallet_Address}`}
                    </DetailsText>
                  </DetailsWrapper>
                )}
              </Column2>
            </InfoRow>
          )}
          {loading ? <LoadingSection isSmall /> : (
            <>
              <Divider2 />
              <Map carbonSeq={carbonSeq} setCarbonSeq={setCarbonSeq} nftData={nftData} hectare="avatime_test" />
            </>
          )}
        </GalleryWhiteWrapper>
      </GalleryWrapper>
    </GalleryContainer>
  );
};

export default index;
